import { DashboardLayout } from "@/projects/components/dashboard-layout";
import { SubmissionsPage } from "@/projects/admin/components/submissions-page";

export function AdminSubmissionsPage() {
  return (
    <DashboardLayout
      role="admin"
      title="Video Submissions"
      breadcrumb={["Home", "Submissions"]}
    >
      <SubmissionsPage />
    </DashboardLayout>
  );
}
